<template>
    <div>
        <portal to="modals-sub">
            <contact-create-or-update-modal />
        </portal>
    </div>
</template>

<script>
import { ContactCreateOrUpdateModal } from '@spa/components/Contact';
export default {
    components: { ContactCreateOrUpdateModal }
}
</script>